import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Factura } from './Factura';
import { FacturaDetalle } from './FacturaDetalle';
import { environment } from '../environments/environment';
import { VVentas } from './VVentas';
import { FacturaXls } from './FacturaXls';
import { ventasDia } from './ventasDia';
import { Peso } from './peso';


@Injectable({
  providedIn: 'root'
})
export class FacturaService {



  
  constructor(private http: HttpClient) { }

 
  setActulizarFactura(fact: Factura[]){
    console.log(fact);
    return this.http.put<Factura[]>(environment.apiUrl+"/actulizarFactura",fact);
  }
  setActulizarFacturaRapido(fact: Factura[]){
    console.log(fact);
    return this.http.put<Factura[]>(environment.apiUrl+"/actulizarFactura",fact).
    subscribe({
      next: (response) => console.log("Factura actualizada con éxito", response),
      error: (error) => console.error("Error al actualizar la factura:", error)
    });
  }

  confirmarFacturaXls(fecha:string){
    return this.http.get<FacturaXls[]>(environment.apiUrl+"/confirmarFacturaXls/?fecha=" + fecha);
  }

  listarEmail(){
    return this.http.get<FacturaXls[]>(environment.apiUrl+"/listaEmailXls");
  }

  eliminarFacturaXls(numero:string){
    return this.http.get<FacturaXls[]>(environment.apiUrl+"/eliminarFacturacionXLs/?numero=" + numero);
  }


  


  setActulizarFacturaXls(fact: FacturaXls[]){
    console.log(fact);
    return this.http.put<FacturaXls[]>(environment.apiUrl+"/actulizarFacturaXls",fact);
  }

  listaFacturasAgupadasXls(fecha: string) {  
    
    return this.http.get<FacturaXls[]>(environment.apiUrl+"/listaFacturasAgupadasXls/?fecha=" + fecha);  
  } 

  listaFacturasNumDocXls(numDoc: string) {  
    
    return this.http.get<FacturaXls[]>(environment.apiUrl+"/listaFacturaNumDocXls/?numeroDoc=" + numDoc);  
  } 
  

  getVentas(fecha: string,id: string) {  
    
    return this.http.get<VVentas[]>(environment.apiUrl+"/listarVentas/?fecha=" + fecha+"&id="+id);  
  }  

  getVentasxDocumento(documento: string,id: string) {  
    
    return this.http.get<VVentas[]>(environment.apiUrl+"/listarVentasDocumento/?documento=" + documento+"&id="+id);  
  }  

  getUltimoPeso(id: string) {  
    
    return this.http.get<Peso[]>(environment.apiUrl+"/buscarPeso/?id="+id);  
  }  


  getVentasDia(idEmisor:number,usuario:string,caja:number) {  
    
    return this.http.get<ventasDia[]>(environment.apiUrl+"/ventasDiaCierreCaja/?idEmisor=" + idEmisor+"&usuario="+usuario+"&caja="+caja);  
  }  


  

  getVentasElectronicas(fecha: string,fechaFinal: string,id: string) {  
    
    return this.http.get<VVentas[]>(environment.apiUrl+"/listarElectronicos/?fecha=" + fecha+"&fechaFinal="+fechaFinal+"&id="+id);  
  }  

  anularVenta(idVenta: string) {  
    
    return this.http.get<String[]>(environment.apiUrl+"/anularVenta/?id="+idVenta);  
  }  


  setActulizarDetalle(det: FacturaDetalle[]){
    console.log(det);
    return this.http.put<string>(environment.apiUrl+"actulizarFacturaDetalle",det).subscribe(

      data  => {
      
      console.log("PUT Request is successful ", data);
      
      },
      
      error  => {
      
      console.log("Rrror", error);
      
      }
      
      );
  }


}
